import {Model} from "@/app/Model";

export class FamigliaDashboardFlow {

    public durata_del_processo_active: boolean = false;
    public durata_del_processo: number = 0;
    public durata_del_processo_notNull: boolean = false;
    
    public riferimento_normativo: string = "";
    public tipologia_procedimento: string = "";
    public oggetto_di_giudizio: string = "";

    public addebito: string = "";

    public motivi_addebito_separazione: string = "";

    public regime_mantenimento: string = "";
    public regime_affidamento: string = "";
    public regime_collocamento: string = "";

    public assegnazione_casa_familiare: string = "";

    public valore_assegno_mantenimento_active: boolean = false;
    public valore_assegno_mantenimento_min: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_mantenimento_max: number = Model.lista_valori_assegno_minMax[1];
    public valore_assegno_mantenimento_da: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_mantenimento_a: number = Model.lista_valori_assegno_minMax[1];

    public valore_assegno_contributo_mantenimento_active: boolean = false;
    public valore_assegno_contributo_mantenimento_min: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_contributo_mantenimento_max: number = Model.lista_valori_assegno_minMax[1];
    public valore_assegno_contributo_mantenimento_da: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_contributo_mantenimento_a: number = Model.lista_valori_assegno_minMax[1];

    public valore_assegno_divorzile_active: boolean = false;
    public valore_assegno_divorzile_min: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_divorzile_max: number = Model.lista_valori_assegno_minMax[1];
    public valore_assegno_divorzile_da: number = Model.lista_valori_assegno_minMax[0];
    public valore_assegno_divorzile_a: number = Model.lista_valori_assegno_minMax[1];
    
    public id_localita: string = "";
    public giudice: string = "";

    public data_active: boolean = false;
    public data_min: number = Model.lista_anno_minMax[0];
    public data_max: number = Model.lista_anno_minMax[1];
    public data_da: number = Model.lista_anno_minMax[0];
    public data_a: number = Model.lista_anno_minMax[1];

    public paginazione_tot: number = 0;
    public paginazione_start: number = 0;
    public paginazione_rows: number = Model.pagination_size;
    public paginazione_pages: number = 0;

    public diritto_paginazione_tot: number = 0;
    public diritto_paginazione_start: number = 0; //numero di pagina
    public diritto_paginazione_rows: number = Model.pagination_size;
    public diritto_paginazione_pages: number = 0;

    public reset(): void {
        this.durata_del_processo_active = false;
        this.durata_del_processo = 0;
        this.durata_del_processo_notNull = false;

        this.riferimento_normativo = "";
        this.tipologia_procedimento = "";
        this.oggetto_di_giudizio = "";

        this.addebito = "";

        this.motivi_addebito_separazione = "";
        this.regime_mantenimento = "";

        this.valore_assegno_mantenimento_active = false;
        this.valore_assegno_mantenimento_da =  this.valore_assegno_mantenimento_min;
        this.valore_assegno_mantenimento_a = this.valore_assegno_mantenimento_max;

        this.valore_assegno_contributo_mantenimento_active = false;
        this.valore_assegno_contributo_mantenimento_da = this.valore_assegno_contributo_mantenimento_min;
        this.valore_assegno_contributo_mantenimento_a = this.valore_assegno_contributo_mantenimento_max;

        this.valore_assegno_divorzile_active = false;
        this.valore_assegno_divorzile_da = this.valore_assegno_divorzile_min;
        this.valore_assegno_divorzile_a = this.valore_assegno_divorzile_max;

        this.regime_affidamento = "";
        this.assegnazione_casa_familiare = "";
        this.regime_collocamento = "";

        this.id_localita = "";
        this.giudice = "";

        this.data_active = false;
        this.data_da = this.data_min;
        this.data_a = this.data_max;

        this.paginazione_tot = 0;
        this.paginazione_start = 0;
        this.paginazione_rows = Model.pagination_size;
        this.paginazione_pages = 0;

        this.diritto_paginazione_tot = 0;
        this.diritto_paginazione_start = 0;
        this.diritto_paginazione_rows = Model.pagination_size;
        this.diritto_paginazione_pages = 0;
    }
}